import { useSavedPaymentMethodCardList } from "./useSavedPaymentMethodCardList";
import { Stancer3dsIframe } from "@common/PaymentIframe";
import { ISimplePaymentMethodCard, SimplePaymentMethodCardList } from "@common/SimplePaymentMethodCardList";

interface IParams {
    amount?: number;
    paymentCreditCardList: ISimplePaymentMethodCard[];
    validatePaymentApiRoute: string;
    payWithSavedCardApiRoute(cardId: string): string;
    successCallback(): void;
}

export const SavedPaymentMethodCardList = (props: IParams) => {
    const { amount, paymentCreditCardList, validatePaymentApiRoute, payWithSavedCardApiRoute, successCallback } = props;

    const { hpp, submitPayment, isPaymentWithSavedCardLoading, errorToDisplay } = useSavedPaymentMethodCardList({
        amount,
        payWithSavedCardApiRoute,
        successCallback,
    });

    if (hpp) {
        return (
            <Stancer3dsIframe
                hpp={hpp}
                successCallback={successCallback}
                validatePaymentApiRoute={validatePaymentApiRoute}
            />
        );
    }

    return (
        <SimplePaymentMethodCardList
            handlePay={submitPayment}
            isPaymentLoading={isPaymentWithSavedCardLoading}
            paymentError={errorToDisplay}
            simplePaymentMethodCardList={paymentCreditCardList}
        />
    );
};
